// extracted by mini-css-extract-plugin
export default {"changeAccount":"ChangeAccount_changeAccount__L22hF","account":"ChangeAccount_account__kAyc7","email":"ChangeAccount_email__fH+3-","changeButton":"ChangeAccount_changeButton__xFsrM"};